/**
 * 地图组件 store
 */

import axios from "../../utils/axios";
import localstore from "../../utils/localStorge";
let state = {
	isSatellite:false,
  isFoucs:false,
	isImageLayer:false,
  imageLayer:{
    center:null,
    zoom:null
  },
  markers:[],
  onlineCount: 0,
  sensorCount: 0,
  deviceCount: 0,
  autoCount: 0,
  map: {
    lat: null,
    lng: null,
    level: null
  },
  farmInfo:null
};

let getters = {
	getBgTitle(state){
		return state.farmInfo&&state.farmInfo.title
	},
  getDeviceCount(state) {
    return [
      {
        id: 0,
        name: "在线设备",
        number: state.onlineCount
      },
      {
        id: 1,
        name: "传感器个数",
        number: state.sensorCount
      },
      {
        id: 2,
        name: "设备个数",
        number: state.deviceCount
      },
      {
        id: 3,
        name: "自动化运行",
        number: state.autoCount
      }
    ]
  },
};

let mutations = {
  setImageLayer(state,payload){
    state.imageLayer = payload
  },
  setMarkers(state,payload){
    state.markers = payload
  },
	setSatellite(state){
		state.isSatellite = !state.isSatellite;
		// localStorage.setItem('regionIsSatellite', state.isSatellite)
		localstore.set('regionIsSatellite',state.isSatellite)
	},
  setFoucs(state){
    state.isFoucs = !state.isFoucs
		// localStorage.setItem('regionIsSatellite',state.isFoucs)
    localstore.set('regionIsFoucs',state.isFoucs)
  },
  setFarmInfo(state,payload){
    state.farmInfo = payload
  },
  setDeviceCount(state, payload) {
    state.onlineCount = payload.onlineCount;
    state.sensorCount = payload.sensorCount;
    state.deviceCount = payload.deviceCount;
    state.autoCount = payload.autoCount;
  },
  setMapMessage(state, payload) {
    state.map.lat = payload.lat;
    state.map.lng = payload.lng;
    state.map.level = payload.level;
  }
};

let actions = {
  mapMessage({rootState}) {
    return new Promise((resolve, reject) => {
      axios.get(`/map?farm_id=${Number(rootState.farmId)}`)
      .then(res => {
        if (res.status === 200) {
          resolve(res.data.data);
        }
      })
      .catch(error => {
        console.log(error);
        reject();
      });
    });
  },
	getDeviceList({rootState}){
		return new Promise((resolve, reject) => {
		  axios.get(`/region_monitor/index?farm_id=${Number(rootState.farmId)}`)
		  .then(res => {
		    if (res.status === 200) {
		      resolve(res.data.data);
		    }
		  })
		  .catch(error => {
		    console.log(error);
		    reject();
		  });
		});
	},
  getRegionList({rootState}){
    return new Promise((resolve, reject) => {
      axios.get(`/region/index?farm_id=${Number(rootState.farmId)}`)
      .then(res => {
        if (res.status === 200) {
          resolve(res.data.data);
        }
      })
      .catch(error => {
        console.log(error);
        reject();
      });
    });
  },
	getFarmInfo({rootState}){
		return new Promise((resolve, reject) => {
		  axios.get(`/farm?id=${Number(rootState.farmId)}`)
		  .then(res => {
		    if (res.status === 200) {
		      resolve(res.data.data);
		    }
		  })
		  .catch(error => {
		    console.log(error);
		    reject();
		  });
		});
	}
};

export default {
  state,
  getters,
  actions,
  mutations
}
